import Splide from "@splidejs/splide";

///
// Gallery slider
///

const imageGallery = document.querySelectorAll('.splide-gallery');
if (imageGallery.length) {
  for (let i = 0; i < imageGallery.length; i++) {

    let splide;
    let previousButton, nextButton;

    document.addEventListener('DOMContentLoaded', function () {
      previousButton = document.querySelector('.image-gallery .previous-button');
      nextButton = document.querySelector('.image-gallery .next-button');

      splide = new Splide('.splide-gallery', {
        autoplay: false,
        interval: 7000,
        arrows: false,
        perPage: 1,
        type: 'loop',
        pagination: true,
        keyboard: false,
        slideFocus: false
      }).mount();

      // To prevent animation issues, let's make every slide visible before a transition happens. Splide will then automatically remove the `.is-visible` class from non-visible slides once the transition is finished.
      splide.on('move', function () {
        const slides = document.querySelectorAll('.image-gallery .splide__slide');
        slides.forEach(function (slide) {
          slide.classList.add('is-visible');
        });
      });

      // Go to the previous slide and stop autoplay when the Previous button is activated
      previousButton.addEventListener('click', function () {
        splide.go('<');
      });

      // Go to the next slide and stop autoplay when the Next button is activated
      nextButton.addEventListener('click', function () {
        splide.go('>');
      });
    });
  }
}
